import { SvgIcon } from '../SvgIcon';
import * as React from 'react';
import { success } from '../../../../styles/colors';

export const SharedNumberIcon = ({
	fillColor = success,
	width = 15,
	height = 14,
	...props
}: React.SVGProps<SVGSVGElement> & { fillColor?: string }) => {
	return (
		<SvgIcon height={height} width={width} viewBox='0 0 15 14' {...props}>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g transform='translate(-77.000000, -662.340161)' fill={fillColor}>
					<g transform='translate(77.000000, 659.340161)'>
						<g transform='translate(0.000000, 3.000000)'>
							<polygon points='10.5172447 6 8 3.52422714 8.94563867 2.59416795 10.4416738 4.0655558 13.9841406 0 15 0.856391142' />
							<path d='M1.36842105,2.36842105 L1.36842105,5.78947368 C1.36842105,9.56221053 4.43778947,12.6315789 8.21052632,12.6315789 L11.6329474,12.6315789 L11.6315789,9.89473684 L8.89473684,9.89473684 L8.89473684,10.5789474 C8.89473684,10.9566316 8.58821053,11.2631579 8.21052632,11.2631579 C5.13978947,11.2631579 2.78610526,8.91426316 2.73684211,5.80042105 C2.73410526,5.61705263 2.80457895,5.44052632 2.93321053,5.30915789 C3.06184211,5.17847368 3.23768421,5.10526316 3.42105263,5.10526316 L4.10526316,5.10526316 L4.10526316,2.36842105 L1.36842105,2.36842105 Z M11.6315789,14 L8.21052632,14 C3.68310526,14 0,10.3168947 0,5.78947368 L0,2.36842105 C0,1.61373684 0.613736842,1 1.36842105,1 L4.10526316,1 C4.85994737,1 5.47368421,1.61373684 5.47368421,2.36842105 L5.47368421,5.10526316 C5.47368421,5.83873684 4.89347368,6.43947368 4.16821053,6.47231579 C4.46721053,8.24031579 5.78773684,9.56494737 7.52768421,9.84136842 C7.55505263,9.11131579 8.15784211,8.52631579 8.89473684,8.52631579 L11.6315789,8.52631579 C12.3862632,8.52631579 13,9.14005263 13,9.89473684 L13,12.6315789 C13,13.3862632 12.3862632,14 11.6315789,14 L11.6315789,14 Z' />
						</g>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
};
